import { ServerEvent } from "@/common/notification";
import {
	AicLockActions,
	useAicLockStore,
} from "@/common/stores/nonpersistingStores/aicLock";
import { notificationListener } from "@/hooks/notification";
import { fetchAicLockStatus } from "@/repository/queryFns/aicLocking";
import { useAuth } from "@/hooks/authentication";
import { useEffect } from "react";

interface AicLockStateChangedPayload {
	isLocked: boolean;
	lockedAt?: string;
}

export const useAicLockManager = () => {
	const authContext = useAuth();
	const setAicLockState = useAicLockStore(
		(actions: AicLockActions) => actions.setAicLockState
	);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		fetchAicLockStatus()
			.then((status) => setAicLockState(status.isLocked, status.lockedAt ?? null))
			.catch((e) => console.warn('[AicLockManager] initial lock status fetch failed', e));
	}, [authContext.isLogged]);

	// Update store on real-time lock state changes
	notificationListener(
		ServerEvent.AicLockStateChanged,
		(payload: AicLockStateChangedPayload) => {
			setAicLockState(payload.isLocked, payload.lockedAt ?? null);
		}
	);
};
